var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.154837ee85bf81718ac3832d55b5939f.svg";
export { ForwardRef as ReactComponent };